import React from 'react'

export default function LogOut() {
  return (
    <div>LogOut</div>
  )
}
